import { ActionIcon, Group, Indicator, Menu, Stack, Switch, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { IconFilter, IconFilterFilled } from "@/components/icons";

import type { FC } from "react";

const switchPointerStyles = {
  root: { cursor: "pointer" },
  track: { cursor: "pointer" },
  thumb: { cursor: "pointer" },
};

export type ChartFiltersPopoverProps = {
  onShowOutliersChange: (value: boolean) => void;
  onShowReplicasChange: (value: boolean) => void;
  showOutliers: boolean;
  showReplicas: boolean;
};

export const ChartFiltersPopover: FC<ChartFiltersPopoverProps> = ({
  onShowOutliersChange,
  onShowReplicasChange,
  showOutliers,
  showReplicas,
}) => {
  const { t } = useTranslation();
  const hasActiveFilters = !showOutliers || !showReplicas;

  return (
    <Menu closeOnItemClick={false} position="bottom-end" shadow="md" width="max-content">
      <Menu.Target>
        <Indicator color="warning" disabled={!hasActiveFilters} offset={4} processing size={8}>
          <ActionIcon
            aria-label={t("components.AuctionsChart.filters")}
            size="lg"
            variant={hasActiveFilters ? "filled" : "light"}
          >
            {hasActiveFilters ? <IconFilterFilled size={18} /> : <IconFilter size={18} />}
          </ActionIcon>
        </Indicator>
      </Menu.Target>

      <Menu.Dropdown p="sm" style={{ zIndex: 200 }}>
        <Stack gap="md" p="md">
          <Group gap="md" justify="space-between" wrap="nowrap">
            <Text c="inherit" size="sm" style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
              {t("components.AuctionsChart.show_replicas")}
            </Text>
            <Switch
              checked={showReplicas}
              onChange={(event) => onShowReplicasChange(event.currentTarget.checked)}
              styles={switchPointerStyles}
            />
          </Group>
          <Group gap="md" justify="space-between" wrap="nowrap">
            <Text c="inherit" size="sm" style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
              {t("components.AuctionsChart.show_outliers")}
            </Text>
            <Switch
              checked={showOutliers}
              onChange={(event) => onShowOutliersChange(event.currentTarget.checked)}
              styles={switchPointerStyles}
            />
          </Group>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
};
